/**
 * 共通リクエスト.
 */
export class PlessRequest {

  /** 送信オブジェクト. */
  data: any = null;

  constructor(data: any = null) {
    this.data = data;
  }
}
